export function SortCodeFormatter(sortCode) {

    if (sortCode) {
        if(sortCode.toString().length === 6)
{
        let SortCode = sortCode.toString();
     
        let FormattedSortCode = SortCode.substring(0, 2) + "-" + SortCode.substring(2, 4) + "-" + SortCode?.substring(4, 6);
      
        return FormattedSortCode;
}
    }
    return sortCode;
}


export function SortCodeToSixDigits(sortCode1,sortCode2,sortCode3) {

let   sortCode= sortCode1 +sortCode2+sortCode3;
    return sortCode;
}


export function mask  (cc, num = 4, mask = '*') {
    
        let maskedata= `${cc}`.slice(-num).padStart(`${cc}`.length, mask);
        return maskedata;
}